// LoraInfo.js
function LoraInfo() {
  return (
    <div className="col-md-6 text-center loraInfo-section" data-aos="fade-left" data-aos-delay="300">
      <h2 className="mb-4">What is LoRa?</h2>
      <i className="fas fa-broadcast-tower fa-4x mb-5 icon" style={{ color: "#336699" }}></i>
      <p className="w-500">
        LoRa (Long Range) technology is a better option.<br/> It’s low-cost, low-power, and doesn’t rely on mobile networks, making it ideal for rural farms. A smart collar using LoRa, solar power, GPS, and motion sensors can provide an affordable and reliable way to track free-range cattle. This project aims to create that solution for Sri Lankan farmers.
      </p>
    </div>
  );
}

export default LoraInfo;
